var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58874 26.1794C7.89569 26.1794 8.20263 25.8653 8.20263 25.5512V12.9871C8.20263 12.673 7.89569 12.3589 7.58874 12.3589C7.2818 12.3589 6.97485 12.673 6.97485 12.9871V25.5512C6.97485 25.8653 7.2818 26.1794 7.58874 26.1794Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 26.1794C12.8071 26.1794 13.114 25.8653 13.114 25.5512V12.9871C13.114 12.673 12.8071 12.3589 12.5001 12.3589C12.1932 12.3589 11.8862 12.673 11.8862 12.9871V25.5512C11.8862 25.8653 12.1932 26.1794 12.5001 26.1794Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.411 26.1794C17.718 26.1794 18.0249 25.8653 18.0249 25.5512V12.9871C18.0249 12.673 17.718 12.3589 17.411 12.3589C17.1041 12.3589 16.7971 12.673 16.7971 12.9871V25.5512C16.7971 25.8653 17.1041 26.1794 17.411 26.1794Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13328 30.5767H19.8666C21.5855 30.5767 22.9361 29.1946 22.9361 27.4357V9.21772C23.9797 9.21772 24.7777 8.33824 24.7777 7.33311V5.44849C24.7777 4.44336 23.9797 3.56388 22.9361 3.56388H16.7972V1.05106C16.7972 0.674134 16.4902 0.422852 16.1833 0.422852H8.81661C8.50967 0.422852 8.20272 0.674134 8.20272 1.05106V3.56388H2.06383C1.08161 3.56388 0.222168 4.44336 0.222168 5.44849V7.33311C0.222168 8.33824 1.08161 9.21772 2.06383 9.21772V27.4357C2.06383 29.1946 3.41439 30.5767 5.13328 30.5767ZM9.4305 1.67926H15.5694V3.56388H9.4305V1.67926ZM1.44995 7.33311V5.44849C1.44995 5.07157 1.6955 4.82029 2.06383 4.82029H8.81661H16.1833H22.9361C23.243 4.82029 23.5499 5.07157 23.5499 5.44849V7.33311C23.5499 7.64721 23.243 7.96131 22.9361 7.96131H22.3222H2.67772H2.06383C1.6955 7.96131 1.44995 7.64721 1.44995 7.33311ZM21.7083 9.21772V27.4357C21.7083 28.5036 20.9102 29.3203 19.8666 29.3203H5.13328C4.15106 29.3203 3.29161 28.5036 3.29161 27.4357V9.21772H21.7083Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5556,
    height: 30.1538,
    fill: "white",
    transform: "translate(0.222168 0.422852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete-white.fba315779c0c818b8b7405451fbbfbff.svg";
export { ForwardRef as ReactComponent };